import {
  faBaseballBall,
  faCalendar,
  faMoneyBillWave,
  faStar,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import React, { useContext, useEffect, useState } from "react";
import InternalRouter from "../components/elements/InternalRouter.Element";
import LoadingElement from "../components/elements/Loading.Element";
import { firebaseContext } from "../contexts/FirebaseContext";
import { InternalRoute } from "../interfaces/InternalRoute.Interface";
import { User } from "../interfaces/User.Interface";
import { ROUTES } from "../routes";
import { Button, Spinner } from "@blueprintjs/core";
import "./User.Styles.scss";
import { PlayerRequest } from "../interfaces/PlayerRequest.interface";
import { DB_REF } from "../constants/DB";
import profileImg from "../img/profile_default.jpg";

export default function UserScreen() {
  const [user, setUser] = useState<User | null>(null);
  const [reqPlayer, setReqPlayer] = useState(false);
  const [canShowRoute, setCanShowRoute] = useState(false);
  const [reqLoading, setReqLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const firebase = useContext(firebaseContext);

  const userRoutes: InternalRoute[] = [
    {
      icon: faUser,
      route: ROUTES.userInfo,
      title: "Information",
    },
    {
      icon: faStar,
      route: ROUTES.userRatings,
      title: "Ratings",
    },
    {
      icon: faBaseballBall,
      route: ROUTES.userMatches,
      title: "Matches",
    },
    {
      icon: faCalendar,
      route: ROUTES.userAttendance,
      title: "Matches",
    },
    {
      icon: faMoneyBillWave,
      route: ROUTES.userContributions,
      title: "Matches",
    },
  ];

  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      try {
        setUser(user as any);
        if (user) {
          const db = firebase.firestore();
          const docs = await db
            .collection("players")
            .where("uid", "==", user.uid)
            .get();

          if (!docs.empty) {
            setCanShowRoute(true);
          } else {
            const request = await db
              .collection("player_requests")
              .doc(user.uid)
              .get();

            if (!request.exists) {
              setReqPlayer(true);
            }
          }
        }
        setLoading(false);
      } catch (err) {
        console.log(err);
      }
    });
  }, [firebase]);

  const onClickRequest = async () => {
    setReqLoading(true);

    const db = firebase.firestore();
    const col = db.collection(DB_REF.playerRequests);
    const doc = await col.doc(user!.uid).get();

    if (!doc.exists) {
      const req: PlayerRequest = {
        accepted: "waiting",
        user: {
          displayName: user!.displayName,
          email: user!.email,
          photoURL: user!.photoURL,
          uid: user!.uid,
        },
      };

      col.doc(user!.uid).set(req);
      setReqPlayer(false);
      setReqLoading(false);
    }
  };

  if (loading) {
    return <LoadingElement />;
  }

  if (reqPlayer) {
    return (
      <div
        style={{
          height: "100vh",
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ padding: 30 }}>
          Click below to request to become a MustangsFC player!
        </div>
        {reqLoading ? (
          <Spinner />
        ) : (
          <Button onClick={onClickRequest} text="Click here" />
        )}
      </div>
    );
  }

  if (canShowRoute) {
    return (
      <div className="userdata-container">
        <div className="userdata-image-container">
          {user && <img src={user?.photoURL || profileImg} alt="" />}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            minHeight: "60px",
            alignItems: "center",
          }}
        >
          <h1>{user?.displayName}</h1>
        </div>
        <div className="user-router-container">
          <InternalRouter internalRoutes={userRoutes} />
        </div>
      </div>
    );
  } else {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        Your request to become a player has been recived by the admin board
        please wait till we process your request
      </div>
    );
  }
}
